<template>
	<el-dialog title="请选择" append-to-body :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
		<div class="table">
			<el-button @click="handleSelect()" type="danger">选择</el-button>
			<el-table ref="table" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column fixed prop="filename" align="center" label="文件名称" width="100">
				</el-table-column>
				<el-table-column prop="format" align="center" label="文件后缀" width="100">
				</el-table-column>
				<el-table-column prop="type" align="center" label="类型" width="120">
				</el-table-column>
				<el-table-column prop="path" align="center" label="文件相对路径" width="480">
				</el-table-column>
				<el-table-column prop="filesize" align="center" label="文件大小" width="120">
				</el-table-column>
				<el-table-column prop="createtime" align="center" label="创建时间" width="150">
				</el-table-column>
				<!-- <el-table-column fixed="right" align="center" label="操作" width="120">
					<template slot-scope="scope">
						<el-button type="text" @click="drawer = true" size="small">
							详情
						</el-button>
						<el-button type="text" style="color: red;" @click="handleDelete(scope.row)" size="small">
							删除
						</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</div>
		
		<div class="searchBlock bottomFy" style="justify-content: space-between;">
			<div class="leftBottom searchBlock">
				<div>已勾选 {{ selection.length }} 个选项</div>
				<div style="margin-left: 10px;color: #2e4fed;cursor: pointer;" @click="isSelection(isSelected)">
					{{ isSelected ? '取消勾选全部' : '勾选全部' }}
				</div>
			</div>
			<div class="rightBottom searchBlock">
				<el-pagination :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10"
					layout="total,  sizes" :total="total">
				</el-pagination>
				<div class="page-wrapper">
					<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>
		
					<div class="page-input">
						<el-input style="width: 70px;margin-right: 10px;" type="number" v-model.number="inputPage"
							@keyup.enter="jumpPage"></el-input>
						<span>/ {{ totalPage }}</span>
					</div>
		
					<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
				</div>
			</div>
			<!-- @size-change="handleSizeChange" @current-change="handleCurrentChange" -->
		
		</div>
	</el-dialog>

</template>

<script>
	export default {
		props: {
			type: {
				type: [Number, String],
				default: '',
			},
			visible: {
				type: Boolean,
				default: false,
			},
			row: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				// dialogVisible: false,
				setObj: {},
				form: {
					name: '',
					content: '',
					material: {}
				},
				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 40,
				totalPage: 4,
				tableData: [],
				selection: [],
			};
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			},
			isSelected() {
				return this.selection.length == this.tableData.length && this.tableData.length
			}
		},
		watch: {
			type: {
				immediate: true,
				handler(val) {
					if (val) {
						let obj2 = {
							title: '话术库'
						}
						let obj1 = {
							title: '分类'
						}
						this.setObj = val == 1 ? obj1 : obj2
					}
				}
			}
		},
		methods: {
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(() => {
						done();
						this.$emit('update:visible', false)
					})
					.catch(() => {});
			},
			handleSelect() {
				this.$confirm('确认选择？')
					.then(() => {
						this.$emit('selectObj', this.selection)
						this.$emit('update:visible', false)
					})
					.catch(() => {});
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getMaterialList, {
					page: this.page,
					limit: this.pageSize
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
			isSelection(type) {
				if (type) {
					// 取消全选
					this.$refs.table.clearSelection()
				} else {
					// 全选
					this.tableData.forEach(row => {
						this.$refs.table.toggleRowSelection(row, true)
					})
				}
			},
		},
		mounted() {
			this.getList()
		}
	};
</script>

<style lang="scss" scoped>
	.searchBlock {
		display: flex;
		align-content: center;
	}
	
	.table {
		margin: 10px 0;
	}
	
	.bottomFy {
		margin-top: 10px;
	
		.page-wrapper {
			display: flex;
			align-items: center;
			/* height: 80%; */
	
			.page-input {
				margin: 0px 10px;
				display: flex;
				align-items: center;
			}
		}
	}
</style>